import { Component } from '@angular/core';
import { App } from 'ionic-angular';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';


import { User } from '../../providers/providers';

@Component({
  templateUrl: 'terms-of-service.html'
})
export class TermsOfServicePage {  

    constructor(
        public navCtrl: NavController,
        public navParams:NavParams,
        public loadingCtrl: LoadingController,
        public events:Events) {
          
      } 

 
}



// WEBPACK FOOTER //
// ./src/pages/terms-of-service/terms-of-service.ts